export default __webpack_public_path__ + "static/media/shape-52.6d51ed94.png";